import Paging from "./paging";

export default Paging;